import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  dialogRoot: {
    '& .base-dialog-actions button:first-child': {
      minWidth: '150px'
    },
    '& .base-dialog-actions button:last-child': {
      minWidth: '180px'
    }
  },
  contentWrapper: {
    display: 'flex',
    flexFlow: 'column nowrap',
    height: '100%',
    boxSizing: 'border-box'
  },
  headerText: {
  },
  subtitleText: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    lineHeight: '22px',
    color: '#545964',
    marginBottom: '8px'
  },
  sampleTemplateLink: {
    border: 'none',
    background: 'none',
    padding: 0,
    margin: 0,
    fontFamily: 'inherit',
    fontSize: '14px',
    fontWeight: 500,
    color: '#652d90',
    cursor: 'pointer',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  codeHeader: {
    fontFamily: 'monospace',
    backgroundColor: '#f5f5f5',
    padding: '2px 6px',
    borderRadius: '4px',
    color: '#7f7182'
  },
  dropzoneContainer: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '8px',
    border: '1px dashed #c0bbc0',
    backgroundColor: '#fbfbfb',
    padding: '16px',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    minHeight: '300px'
  },
  uploadInput: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  uploadIcon: {
    fill: '#867d86',
    marginBottom: '16px'
  },
  dragText: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    color: '#333333',
    marginBottom: '16px'
  },
  chooseFileBtn: {
    backgroundColor: '#40204d',
    color: 'white',
    textTransform: 'none',
    fontWeight: 500,
    padding: '8px 24px',
    borderRadius: '6px',
    marginBottom: '16px',
    '&:hover': {
      backgroundColor: '#30183a'
    }
  },
  limitsText: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    color: '#7f7182'
  },
  errorText: {
    color: '#d32f2f',
    fontSize: '14px',
    marginTop: '12px'
  },
  fileAndResultsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  fileInfoBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px',
    backgroundColor: '#ffffff',
    border: '1px solid #e0e0e0',
    borderRadius: '6px',
    marginBottom: '12px'
  },
  fileInfoLeft: {
    display: 'flex',
    alignItems: 'center'
  },
  fileIcon: {
    marginRight: '16px'
  },
  fileName: {
    fontFamily: 'Roboto',
    fontSize: '15px',
    fontWeight: 500,
    color: '#333333',
    marginBottom: '4px'
  },
  fileDetails: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    color: '#7f7182'
  },
  removeFileBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      opacity: 0.7
    }
  },
  validationSection: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflow: 'hidden'
  },
  validationTitle: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: 600,
    color: '#333333'
  },
  importingRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '12px'
  },
  importingIndicator: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  resultsContainer: {
    flexGrow: 1,
    overflowY: 'auto',
    border: '1px solid #e0e0e0',
    borderRadius: '6px',
    backgroundColor: '#ffffff'
  },
  resultRow: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: '12px 16px',
    borderBottom: '1px solid #e0e0e0',
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  resultGood: {
    backgroundColor: '#eaf4ea'
  },
  resultWarn: {
    backgroundColor: '#fffcf2'
  },
  resultError: {
    backgroundColor: '#fff5f5'
  },
  resultText: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    color: '#333333',
    lineHeight: '20px'
  },
  summaryText: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 500,
    color: '#333333'
  }
}));

export default useStyles;
